"use client";

import type { CSSProperties } from "react";
import { SalifySocialIcon } from "src/lib/components/ui/icon/social-icon";
import { SalifyLinkV2 } from "src/lib/components/ui/link/link";
import type { SocialGroupInterface } from "src/lib/utils/interfaces";
import svgPaths from "./svg-bvmy9onrap";

function ContactInfoContainer({ phone }: { phone: string }) {
  return (
    <div
      className="content-stretch flex gap-[4px] items-center relative shrink-0"
      data-name="Contact info container"
    >
      <div className="overflow-clip relative shrink-0 size-[20px]" data-name="+84 888 2">
        <div
          className="-translate-x-1/2 -translate-y-1/2 absolute h-[13.825px] left-[calc(50%+0.09px)] top-[calc(50%-0.09px)] w-[13.815px]"
          data-name="Icon"
        >
          <svg
            className="absolute block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 13.8148 13.8253"
          >
            <path
              clipRule="evenodd"
              d={svgPaths.p39b71800}
              fill="var(--fill-0, #FFA411)"
              fillRule="evenodd"
              id="Icon"
            />
          </svg>
        </div>
      </div>
      <p className="font-normal leading-[normal] not-italic relative shrink-0 text-[#303030] text-[14px] whitespace-nowrap">
        {phone}
      </p>
    </div>
  );
}

function ContactInfoContainer1({ email }: { email: string }) {
  return (
    <div
      className="content-stretch flex gap-[4px] items-center relative shrink-0"
      data-name="Contact info container"
    >
      <div className="overflow-clip relative shrink-0 size-[20px]" data-name="+84 888 2">
        <div
          className="-translate-x-1/2 -translate-y-1/2 absolute h-[11px] left-1/2 top-1/2 w-[14px]"
          data-name="Union"
        >
          <svg
            className="absolute block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 14 11"
          >
            <path d={svgPaths.pa516b00} fill="var(--fill-0, #FFA411)" id="Union" />
          </svg>
        </div>
      </div>
      <p className="font-normal leading-[normal] not-italic relative shrink-0 text-[#303030] text-[14px] whitespace-nowrap">
        {email}
      </p>
    </div>
  );
}

function ContactInfoRow({ phone, email }: { phone: string; email: string }) {
  return (
    <div
      className="content-stretch flex gap-[12px] items-center relative shrink-0"
      data-name="Contact info row"
    >
      <ContactInfoContainer phone={phone} />
      <div className="flex flex-row items-center self-stretch">
        <div
          className="flex h-0 items-center justify-center relative self-center shrink-0 w-0"
          style={
            {
              containerType: "size",
              "--transform-inner-width": "1185",
              "--transform-inner-height": "22",
            } as CSSProperties
          }
        >
          <div className="flex-none rotate-90 w-[100cqh]">
            <div className="h-0 relative w-full">
              <div className="absolute inset-[-1px_0_0_0]">
                <svg
                  className="block size-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 20 1"
                >
                  <line id="Line 1" stroke="var(--stroke-0, #D5D5D5)" x2="20" y1="0.5" y2="0.5" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactInfoContainer1 email={email} />
    </div>
  );
}

/** FullWidth `SocialLinksRow` + `SocialLinkContainer` — icon qua `SalifySocialIcon` như các header khác */
function SocialLinksRow({ socialGroup }: { socialGroup: SocialGroupInterface[] | undefined }) {
  return (
    <div
      className="content-stretch flex items-start relative shrink-0"
      data-name="Social links row"
    >
      {!!socialGroup?.length &&
        socialGroup.map((item, index) => {
          if (!item.url || !item.type) return null;

          return (
            <SalifyLinkV2
              href={item.url}
              key={index}
              className="content-stretch flex items-center justify-center px-[14px] py-[10px] relative shrink-0"
              data-name="Social link container"
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
            >
              <div
                aria-hidden="true"
                className="absolute border-[#e3e3e3] border-l border-solid inset-0 pointer-events-none"
              />
              <div className="flex flex-col font-['Font_Awesome_6_Brands:Regular',sans-serif] justify-center leading-[0] not-italic relative shrink-0 text-[#ffa411] text-[14px] text-center whitespace-nowrap">
                <p className="leading-[normal] m-0 flex items-center justify-center">
                  <SalifySocialIcon type={item.type} color="#ffa411" size={14} />
                </p>
              </div>
            </SalifyLinkV2>
          );
        })}
    </div>
  );
}

/** FullWidth `ContainerMaxWidth1120Px` — contact trái, social phải */
export function DathaconsHeaderTopBar({
  phone,
  email,
  socialGroup,
}: {
  phone: string;
  email: string;
  socialGroup: SocialGroupInterface[] | undefined;
}) {
  return (
    <div
      className="bg-white content-stretch flex flex-col items-center relative shrink-0 w-full"
      data-name="Header section"
    >
      <div
        aria-hidden="true"
        className="absolute border-[#e3e3e3] border-b border-solid inset-0 pointer-events-none"
      />
      <div
        className="content-stretch flex items-center justify-between relative shrink-0 w-[1120px] max-w-full"
        data-name="Container max-width 1120px"
      >
        <ContactInfoRow phone={phone} email={email} />
        <SocialLinksRow socialGroup={socialGroup} />
      </div>
    </div>
  );
}
